import { render } from "./trainAdd.vue?vue&type=template&id=7b7b50c3&scoped=true"
import script from "./trainAdd.vue?vue&type=script&lang=js"
export * from "./trainAdd.vue?vue&type=script&lang=js"

import "./trainAdd.vue?vue&type=style&index=0&id=7b7b50c3&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7b50c3"]])

export default __exports__